
import { Options, Vue } from 'vue-class-component'

import api from '@/api'
import { toDate } from '../utils/common'
import store from '../store'

@Options({
  components: {}
})
export default class change extends Vue {
  toDate = toDate;
  d:any = {};
  loading = false

  changePage (page:number) {
    console.log(page)
  }

  created () {
    this.loading = true
    api.getChange(store.getters['company/get']).then((data:any) => {
      this.d = data
    }).finally(() => {
      this.loading = false
    })
  }
}
